import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  Alert,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import {
  editCompanyFieldChange,
  editEmailFieldChange,
  editNumberField,
  editNumberFieldChange as editNumberFieldChangeAction,
  getCompanyNumbers,
  getNumberByID,
  uploadFile,
} from '../actions/Numbers';
import { PHONE_NUMBER_TYPES } from '../lib/constants';
// import EmailTypeSelect from './EmailTypeSelect';
import MultiInput from './MultiInput';
import MultiInputDrag from './MultiInputDrag';

function findSelectedType(type) {
  if (!type) {
    return PHONE_NUMBER_TYPES[0];
  }
  return PHONE_NUMBER_TYPES.find(numberType => numberType?.value === type);
}

class EditPhoneNumber extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      enableDropdopwn: props.phone.numObj.type === 'unassigned' ? true : false,
      selectedType: findSelectedType(props.phone.numObj.type),
    };
  }

  async componentDidMount() {
    const { box, editNumberFieldChange, editNumberField, phone } = this.props;
    editNumberFieldChange('number', phone.numObj.number);
    editNumberFieldChange('company', box.assignedTo._id);
    editNumberFieldChange('type', phone.numObj.type);
    editNumberField('numberByID', phone.numObj);
    editNumberFieldChange('companyName', box.assignedTo.name);
    editNumberFieldChange('forwardUris', phone.numObj.forwardUris);
    editNumberFieldChange('assignedTo', { _id: box.epikBoxUser._id, email: box.epikBoxUser.email });
    if (!phone.numObj.groupMembers.includes(phone.obj.extension)) {
      editNumberFieldChange('groupMembers', phone.numObj.groupMembers.concat(phone.obj.extension));
    }
  }

  onNumberTypeSelect = numberType => {
    const { editNumberFieldChange } = this.props;
    this.setState({ selectedType: numberType });
    editNumberFieldChange('type', numberType?.value);
  };

  onEditArrChange = (ev, type) => {
    this.props.editNumberFieldChange(type, ev);
  };

  onEditNumberChange = ev => {
    const { name, value } = ev.target;
    const reg = /^[+]*[0-9]{1,11}$/g;
    if (reg.test(value)) {
      this.props.editNumberFieldChange(name, value);
    }
  };

  renderTypes = () => {
    const { selectedType } = this.state;
    return PHONE_NUMBER_TYPES.filter(numberType => numberType?.value !== selectedType?.value).map(
      numberType => {
        return (
          <DropdownItem key={numberType?.value} onClick={() => this.onNumberTypeSelect(numberType)}>
            {numberType.label}
          </DropdownItem>
        );
      },
    );
  };

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  move = (from, to, arr = this.props.number.groupMembers) => {
    const clone = [...arr];
    Array.prototype.splice.call(clone, to, 0, Array.prototype.splice.call(clone, from, 1)[0]);
    this.props.editNumberFieldChange('groupMembers', clone);
  };

  render() {
    const { number } = this.props;
    return (
      <div className="container numbers-container">
        <div className="row">
          <div className="text-left" style={{ width: '100%' }}>
            <FormGroup row>
              <Col sm={6}>
                <Label for="number" sm={12}>
                  Number
                </Label>
                <Input
                  disabled={true}
                  required
                  type="text"
                  name="number"
                  value={number && number.number}
                  onChange={this.onEditNumberChange}
                  maxLength={12}
                />
              </Col>
              <Col sm={6}>
                <Label for="type" sm={12}>
                  Type
                </Label>
                <Dropdown name="type" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                  <DropdownToggle caret>{this.state.selectedType?.label}</DropdownToggle>
                  <DropdownMenu>{this.renderTypes()}</DropdownMenu>
                </Dropdown>
              </Col>
            </FormGroup>

            <FormGroup row>
              <Col sm={6}>
                <Label for="company" sm={12}>
                  Company
                </Label>
                <Input
                  disabled={true}
                  required
                  type="text"
                  name="number"
                  value={number && number.companyName}
                  onChange={this.onEditNumberChange}
                />
              </Col>
              <Col sm={6}>
                <Label for="type" sm={12}>
                  User
                </Label>
                <Input
                  disabled={true}
                  required
                  type="text"
                  name="number"
                  value={number && number.assignedTo && number.assignedTo.email}
                  onChange={this.onEditNumberChange}
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              {this.state.selectedType?.value !== 'unassigned' ? (
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    Forward Uri(s)
                  </Label>
                  <MultiInput
                    inputData={(number && number.forwardUris) || []}
                    onChange={e => {
                      this.onEditArrChange(e, 'forwardUris');
                    }}
                    disabledAdmin={true}
                  />
                </Col>
              ) : null}

              {this.state.selectedType?.value === 'hunt' ||
              this.state.selectedType?.value === 'ringGroup' ? (
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    Group Member(s)
                  </Label>
                  {number && number.groupMembers && number.groupMembers.length !== 0 ? (
                    <MultiInputDrag
                      inputData={number && number.groupMembers}
                      move={this.move}
                      disabledAdmin={true}
                    />
                  ) : (
                    <Alert color="info">No Group Member(s)</Alert>
                  )}
                </Col>
              ) : null}
            </FormGroup>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  number: state.UIState.numbers.editNumber,
  numberByID: state.AppState.numbers.numberByID,
  company: state.UIState.numbers.editNumber.company,
  companies: state.AppState.companies,
  type: state.UIState.numbers.editNumber.type,
  box: state.AppState.boxDetails.box,
});

const mapDispatchToProps = dispatch => ({
  editNumberFieldChange: (name, value) => dispatch(editNumberFieldChangeAction(name, value)),
  editNumberField: (name, value) => dispatch(editNumberField(name, value)),
  editCompanyFieldChange: (name, value) => dispatch(editCompanyFieldChange(name, value)),
  editEmailFieldChange: emails => dispatch(editEmailFieldChange(emails)),
  getCompanyNumbers: (token, id, uid) => dispatch(getCompanyNumbers(token, id, uid)),
  getNumberByID: (token, id) => dispatch(getNumberByID(token, id)),
  uploadFile: (token, id, files) => dispatch(uploadFile(token, id, files)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditPhoneNumber);
